export const GET_ALL_INVOICES = `
	query {
		getAllInvoices {
			bankName
			id
			clientId
			itinerarioID
			file
			to
			Codigo
			total
			totalPrice
			taxInformation {
				applyIgv
				taxCondition
				taxRate
				netAmount
				taxAmount
				totalAmount
				residentPassengerDetected
			}
			totalMontoNotasCredito
			totalPagado
			dueDate
			createdAt
			estado
			fechaLastCobro
			lstPagos {
				id
				tipo
				tipoAbono
				ordenIngresoId
				createdAt
				updatedAt
				monto
				usuario
				fechaPago
			}
		}
	}
`;

export const UPDATE_PAGO_SAF = `
	mutation updatePagoSAF($usuario: String!, $idInvoice: String!, $pagoInvoice: inputPagosInvoice!, $tipoUpdate: String!) {
		updatePagoSAF(usuario: $usuario, idInvoice: $idInvoice, pagoInvoice: $pagoInvoice, tipoUpdate: $tipoUpdate) {
			id
			estado
			totalPagado
			total
			totalPrice
			taxInformation {
				applyIgv
				taxCondition
				taxRate
				netAmount
				taxAmount
				totalAmount
				residentPassengerDetected
			}
		}
	}
`;

export const GET_INVOICES_BY_DATE_RANGE_AND_CLIENT = `
	query getAllInvoiceByDateRangeAndClient($startDate: String!, $endDate: String!, $clientName: String!) {
		getAllInvoiceByDateRangeAndClient(startDate: $startDate, endDate: $endDate, clientName: $clientName) {
			id
			file
			Codigo
			fileName
			fechaOperacionFile
			total
			totalPrice
			taxInformation {
				applyIgv
				taxCondition
				taxRate
				netAmount
				taxAmount
				totalAmount
				residentPassengerDetected
			}
			totalPagado
			lstPagosSAF {
				monto
				createdAt
				periodo
			}
		}
	}
`;
